import { HotRankDetailModel } from "@/api/rank";
import InfiniteScrollContent from "@/components/InfiniteScrollContent";
import { ProductDetailModel, ProductModel } from "@akc/biz-api";
import { InfiniteScroll } from "antd-mobile";
import React from "react";
import TopListView from "../TopLIstView";
import styles from "./index.module.less";

interface ProductListViewProps {
  loading?: boolean;
  productList: ProductModel[];
  rankName?: string;
  rankNo?: string;
  pageName?: string;
  onLoadMore?: () => Promise<void>;
  hasMore?: boolean;
  handleShareProduct?: (product: ProductModel) => void;
}

const ProductListView: React.FC<ProductListViewProps> = ({
  loading,
  productList,
  rankName = "热卖榜",
  rankNo,
  pageName,
  onLoadMore,
  hasMore = false,
  handleShareProduct,
}) => {


  // 构造 HotRankDetailModel 格式的数据来复用 TopListView
  const rankDetail: HotRankDetailModel = {
    rankName,
    rankNo,
    productList,
  };

  return (
    <div className={styles.SingleRankDetailCard}>
      {/* 榜单标题头部 */}
      <div className={styles.header}>
        <img src="https://akim-oss.aikucun.com/20e4636f0cb9659678402b875233d7242a57b0b9_1756545756078_2.png" alt="" className={styles.headerIcon}/>
        <div className={styles.headerTitle}>{rankName}</div>
        <img src="https://akim-oss.aikucun.com/20e4636f0cb9659678402b875233d7242a57b0b9_1756545756078_2.png" alt="" className={`${styles.headerIcon} ${styles.headerIconRight}`}/>
      </div>

      {/* 复用 TopListView 组件 */}
      <div className={styles.TopListViewBox}>
        <TopListView
        loading={loading}
          rankDetail={rankDetail}
          handleShareProduct={handleShareProduct}
          pageName={pageName}
        />
      </div>

      {/* 使用工程统一的上拉加载组件 */}
      {onLoadMore && productList.length > 0 && (
        <div className={styles.InfiniteScrollBox}>
          <InfiniteScroll loadMore={onLoadMore} hasMore={hasMore} threshold={0}>
            <InfiniteScrollContent hasMore={hasMore} />
          </InfiniteScroll>
        </div>
      )}
    </div>
  );
};

export default ProductListView;
